document.addEventListener('DOMContentLoaded', () => {
    if (window.innerWidth <= 768 && $('#idm-slider').hasClass('desktop')){
        $('#idm-slider img').each(function() {
            const altImg = $(this).data('altimg');
            if (altImg) {
                $(this).attr('src', altImg);
            }
        });
    }

    const $slider = $('#idm-slider').slick({
        dots: true,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3500
        //lazyLoad: 'ondemand'
    });

    /*
    const objGTM = new GTM();

    $slider.on('afterChange', (event, slick, currentSlide) => {
        const $el = $(slick.$slides.get(currentSlide));
            let data = {
                'slider_name' : $el.data('sname'),
                'slider_index' : $el.data('sid'),
                'slider_position' : $el.data('spos'),
                'page_url_redirection': $el.attr('href')
            };
            if ($el.data('sproduct')){
                data.id_produit = $el.data('sproduct');
            }
            objGTM.pushSliderEvent('slider_view', data);
    });
    */

    $('.carousel-caption').removeClass('d-none');
    // Force trigger the 'afterChange' event for the initial slide
    $slider.trigger('afterChange', [ $slider.slick('getSlick'), 0 ]);

    function debounce(func, delay) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), delay);
        };
    }
    function handleResize() {
        $slider.slick('setPosition');
    }
    window.addEventListener('resize', debounce(handleResize, 250));
});
